import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: '[aaColumnBar]',
    templateUrl: './column-bar.component.html',
    styleUrls: [
        './column-bar.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnBarComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
